import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Text,
  Flex,
  Button,
  IconButton,
  VStack,
  Divider,
  useToast,
  CloseButton,
  Input,
  ChakraProvider,
  Spinner,
  Box,
} from "@chakra-ui/react";
import { FaRegCopy, FaPen } from "react-icons/fa";
import { useEffect, useState } from "react";
import { cpfFormatter } from "@/utils/cpfFormatter";
import { BrlCurrencyFormatter } from "@/utils/BrlCurrencyFormatter";
import { format } from "date-fns";

import {
  changeProposalStatusToPendingUserReview,
  updateExternalId,
  updateProposalDisbursementDate,
  updateOnlyStatus,
  approveProposal,
  changeUnicoProcess,
} from "@/services/proposal.service";
import { getNaturalPersonById } from "@/services/naturalPerson.service";
import { createBioValidation } from "@/services/bioValidation.service";
import { useNavigate, useParams } from "react-router-dom";
import createTheme from "../../../../theme/theme";
import CustomDatePicker from "@/components/CustomDatePicker";

import BankAndPersonalDetailModal from "@/components/BankAndPersonalDetailModal.ts";
import { getConsignadoProposalById, rejectProposalConsignado } from "@/services/consignado/proposal.service";
import { ProposalConsignadoCustomStatus, IConsignadoProposalDetail, ProposalCustomStatus, ProposalCustomStatusItenStatus } from "@/models/consignado/proposal.model";
import { getOfertaEscolhida } from "@/utils/consignado/ofertaEscolhida";
import { ProposalStatus, StatusRenderer } from "@/utils/consignado/proposalStatusRenderer";
import BankDetailModalConsignado from "../../BankDetailModal";


interface ProposalModalProps {
  isOpen: boolean;
  onClose: () => void;
  proposalId: string | null;
}

export default function FixProposalModalConsignado({
  isOpen,
  onClose,
  proposalId,
}: ProposalModalProps) {
  const { id: paramId } = useParams<{ id: string }>();
  const finalId = proposalId ?? paramId ?? null;
  // const [activeTab, setActiveTab] = useState("");
  const [showOverlayModalBody, setShowOverlayModalBody] = useState(false);
  const [getFixProposalIten, setFixProposalIten] = useState("");
  const [externalId, setExternalId] = useState("");
  const [paymentDate, setPaymentDate] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);

  const [proposal, setProposal] = useState<IConsignadoProposalDetail | null>(null);
  const [isLoading, setIsLoading] = useState(false);;
  const { oferta } = getOfertaEscolhida(proposal?.custom_status);
  const [isBankDetailFormOpen, setIsBankDetailFormOpen] = useState(false);
  const [isBankAndPersonalDetailFormOpen, setIsBankAndPersonalDetailFormOpen] = useState(false);
  const toast = useToast();

  const navigate = useNavigate();

  const computedIsOpen = isOpen ?? Boolean(paramId);
  const handleCloseModal = onClose ?? (() => {
    navigate("/propostas");
  });

  useEffect(() => {
    if (!finalId) return;
    let alive = true;
    setIsLoading(true);
    if (computedIsOpen) {
      setIsLoading(true);
      getConsignadoProposalById(finalId)
        .then((data) => {
          if (alive) setProposal(data ?? null);
        })
        .catch((err) => console.error(err))
        .finally(() => {
          if (alive) setIsLoading(false);
        });
      return () => {
        alive = false;
      };
    }
  }, [computedIsOpen]);


  const permissoesBotoes = [
    { status: 'PENDING_FORMALIZATION', acoes: ['cancelar e desbloquear', 'trocar processo unico', 'alterar para pagamento'] },
    { status: 'PENDING_PAYMENT', acoes: ['cancelar e desbloquear', 'trocar processo unico', 'alterar para pagamento'] },
    { status: 'PENDING_USER_REVIEW', acoes: ['corrigir dados bancarios', 'corrigir proposta', 'corrigir dados biometricos'] },

  ];

  const isAcaoPermitida = (acao: string, statusAtual: ProposalStatus) => {

    const permissao = permissoesBotoes.find(p => p.status === statusAtual);
    return permissao?.acoes.includes(acao);
  }

  const handleBankAndPersonalDataClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.stopPropagation();
    setIsBankAndPersonalDetailFormOpen(true);
  };
  const handleBankDataClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setIsBankDetailFormOpen(true);
  };
  const handleButtonFormalizationClick = async (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.stopPropagation();
    onClose();
    try {
      const naturalPerson = await getNaturalPersonById('');
      const request = {
        proposalId: proposal?.id_proposta,
        naturalPerson: naturalPerson,
      };

      await createBioValidation(request);
      toast({
        title: `Formalização criada com sucesso`,
        description: "A formalização foi criada com sucesso.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error creating bio validation:", error);

      toast({
        title: `Erro ao criar formalização`,
        description: "Ocorreu um erro ao criar a formalização.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };
  const hasErrorCreateProposalBank = (customStatus: ProposalConsignadoCustomStatus |string): boolean => {
    let newCustomStatus: any = {};
    try {
      //@ts-ignore
      newCustomStatus = JSON.parse(customStatus && customStatus !== "" ? customStatus : "{}");
    } catch (e) {
      newCustomStatus = {};
    }
    console.error("Custom Status Array:", newCustomStatus);

    return (
      newCustomStatus?.confirmacao &&
      newCustomStatus?.confirmacao?.criacao_proposta_bancarizadora?.status === "erro"
    );
  };

  const hasErrorBiometricValidation = (customStatus: ProposalConsignadoCustomStatus |string): boolean => {
    let newCustomStatus: any = {};
    try {
      //@ts-ignore
      newCustomStatus = JSON.parse(customStatus && customStatus !== "" ? customStatus : "{}");
    } catch (e) {
      newCustomStatus = {};
    }
    console.error("Custom Status Array:", newCustomStatus);

    return (
      newCustomStatus?.confirmacao &&
      newCustomStatus?.confirmacao?.criacao_processo_seg_identidade?.status === "erro"
    );
  };
  const hasProposalBankDetailsError = (customStatus: string): boolean => {
    let newCustomStatus: ProposalCustomStatus
    try {
      newCustomStatus = customStatus && customStatus !== "" ? JSON.parse(customStatus) : {};
    } catch (e) {
      return false
      // newCustomStatus = {};
    }
    return (
      newCustomStatus?.acoes?.corrigir_dados_bancarios && newCustomStatus?.acoes?.corrigir_dados_bancarios?.status === ProposalCustomStatusItenStatus.AGUARDANDO
    );
  };


  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
    toast({
      title: "Copiado",
      description: "Texto copiado para a área de transferência.",
      status: "success",
      duration: 2000,
      isClosable: true,
    });
  };

  const handleCancelProposal = async (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.stopPropagation();
    try {
      // await updateOnlyStatus(proposal?.id_proposta!, ProposalStatus.CANCELED);
      await rejectProposalConsignado(proposal?.id_proposta!)
      toast({
        title: "Proposta Cancelada",
        description: "Enviamos a proposta para cancelamento.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Erro ao Cancelar",
        description: "Ocorreu um erro ao cancelar a proposta.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handlePayedProposal = async (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.stopPropagation();
    try {
      await updateOnlyStatus(proposal?.id_proposta!, ProposalStatus.PAYED);
      toast({
        title: "Proposta Paga",
        description: "Enviamos a proposta para paga.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Erro ao Pagar Proposta",
        description: "Ocorreu um erro ao pagar a proposta.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };


  const handleProposalPendingUserReview = async (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.stopPropagation();
    try {
      await updateOnlyStatus(proposal?.id_proposta!, ProposalStatus.PENDING_USER_REVIEW);
      toast({
        title: "Proposta em Revisão",
        description: "Enviamos a proposta para revisão do usuário.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Erro ao Alterar a Proposta",
        description: "Ocorreu um erro ao alterar a proposta.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleUpdateProposalExternalId = async (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.stopPropagation();
    try {
      await updateExternalId(proposal?.id_proposta!, externalId);
      toast({
        title: "Id da Bancarizadora Atualizado",
        description:
          "Estamos atualizando o id da bancarizadora em nossa base de dados.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Erro ao Atualizar id da Bancarizadora",
        description:
          "Ocorreu um erro ao tentar atualizar o id da bancarizadora .",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleUpdateProposalPaymentDate = async (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.stopPropagation();
    try {
      const newDate = new Date(paymentDate.toString());

      await updateProposalDisbursementDate(proposal?.id_proposta!, newDate);
      toast({
        title: "Data de Pagamento Atualizada",
        description:
          "Estamos atualizando a data do pagamento em nossa base de dados.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Erro ao Atualizar id da Bancarizadora",
        description:
          "Ocorreu um erro ao tentar atualizar o id da bancarizadora .",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // const getModalSize = () => (activeTab === "seguranca" ? "2xl" : "xl");

  const approveProsal = async () => {
    try {
      await approveProposal(proposal?.id_proposta!!);
      toast({
        title: "Proposta aprovada",
        description: "A proposta foi aprovada com sucesso",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error approving proposal:", error);
      toast({
        title: "Erro",
        description: "Erro ao aprovar proposta",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleChangeProposalStatusToPendingUserReview = async () => {
    if (!proposal?.id_proposta) {
      toast({
        title: "Erro",
        description: "ID da proposta não encontrado.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    try {
      await changeProposalStatusToPendingUserReview(proposal.id_proposta);
      toast({
        title: "Status da proposta atualizado!",
        description: "Os dados foram alterados com sucesso.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Erro ao trocar Status da Proposta",
        description: "Ocorreu um erro inesperado.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  const handleChangeUnicoUnico = async () => {
    if (!proposal?.id_proposta) {
      toast({
        title: "Erro",
        description: "ID da proposta não encontrado.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    try {
      await changeUnicoProcess(proposal.id_proposta);
      toast({
        title: "Processo Único atualizado!",
        description: "Os dados foram alterados com sucesso.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Erro ao trocar processo único",
        description: "Ocorreu um erro inesperado.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };


  const handleFixProposal = async (fixType: string) => {
    if (!proposal?.id_proposta) {
      toast({
        title: "Erro",
        description: "ID da proposta não encontrado.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setFixProposalIten(fixType);
    setShowOverlayModalBody(true);
  };

  const theme = createTheme();
  return (
    <>
      <Modal isOpen={computedIsOpen} onClose={handleCloseModal} >
        <ModalOverlay />
        <ModalContent
          borderRadius={{ base: "20px", md: "20px" }}
          overflow="scroll"
          maxW={{ base: "90%", md: "90%", lg: "800px" }}
        >
          {isLoading ? (
            <ChakraProvider theme={theme}>
              <Box
                height="100%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                padding="3em"
              >
                <VStack spacing={4}>
                  <Spinner size="xl" color="primary" thickness="4px" speed="0.65s" />
                  <Text fontSize="xl" fontWeight="medium">
                    Carregando...
                  </Text>
                </VStack>
              </Box>
            </ChakraProvider>
          ) : !proposal ? (
            <Box p={6}>
              <Text>Proposta não encontrada.</Text>
            </Box>
          ) : (
            <>


              {/* Overlay ModalBody */}
              {showOverlayModalBody && (
                <ModalBody
                  position="absolute"
                  top={0}
                  left={0}
                  width="100%"
                  height="100%"
                  bg="white"
                  zIndex={10}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  boxShadow="lg"
                >
                  <CloseButton
                    position="absolute"
                    top={4}
                    right={4}
                    onClick={() => setShowOverlayModalBody(false)}
                    size="lg"
                  />

                  {getFixProposalIten === "status" && (
                    <>
                      <Text fontSize="2xl" mb={4} textAlign="left" width={"100%"}>
                        Alterar status da Proposta
                      </Text>
                      <Text fontSize="sm" mb={4} textAlign="left" width={"100%"}>
                        Analise os status da proposta e escolha o mais adequado.
                      </Text>

                      <></>

                      <Divider borderColor="gray.500" borderWidth="1px" />



                      <Flex
                        justify="space-between"
                        flexDirection={{ base: "column", md: "row" }}
                        width={"100%"}
                      >
                        <Text
                          fontSize="sm"
                          mb={4}
                          textAlign="left"
                          mt={3}
                          width={"60%"}
                        >
                          Altere o status da proposta na granatech para cancelada
                        </Text>
                        <Button
                          bg="secondary"
                          color="white"
                          fontFamily="Lexend Deca"
                          borderRadius="md"
                          _hover={{ bg: "primary" }}
                          marginTop={4}
                          mb={4}
                          onClick={(event) => handleCancelProposal(event)}
                          px={{ base: 4, md: 8 }}
                          w={{ base: "100%", md: "auto" }}
                        >
                          Cancelar Proposta
                        </Button>
                      </Flex>

                      <Divider borderColor="gray.500" borderWidth="1px" />

                      <Flex
                        justify="space-between"
                        flexDirection={{ base: "column", md: "row" }}
                        width={"100%"}
                      >
                        <Text
                          fontSize="sm"
                          mb={4}
                          textAlign="left"
                          mt={3}
                          width={"60%"}
                        >
                          Altere o status da proposta na granatech para falha de
                          pagamento{" "}
                        </Text>
                        <Button
                          bg="secondary"
                          color="white"
                          fontFamily="Lexend Deca"
                          borderRadius="md"
                          _hover={{ bg: "primary" }}
                          marginTop={4}
                          onClick={() =>
                            handleChangeProposalStatusToPendingUserReview()
                          }
                          px={{ base: 4, md: 8 }}
                          w={{ base: "100%", md: "auto" }}
                          mb={4}
                        >
                          Falha de Pagamento
                        </Button>
                      </Flex>

                      <Divider borderColor="gray.500" borderWidth="1px" />

                      <Flex
                        justify="space-between"
                        flexDirection={{ base: "column", md: "row" }}
                        width={"100%"}
                      >
                        <Text
                          fontSize="sm"
                          mb={4}
                          textAlign="left"
                          mt={3}
                          width={"60%"}
                        >
                          Altere o status da proposta para PAGA na granatech
                        </Text>
                        <Button
                          bg="secondary"
                          color="white"
                          fontFamily="Lexend Deca"
                          borderRadius="md"
                          _hover={{ bg: "primary" }}
                          mb={4}
                          marginTop={4}
                          onClick={(event) => handlePayedProposal(event)}
                          px={{ base: 4, md: 8 }}
                          w={{ base: "100%", md: "auto" }}
                        >
                          Pago
                        </Button>
                      </Flex>

                      <Divider borderColor="gray.500" borderWidth="1px" />

                      <Flex
                        justify="space-between"
                        flexDirection={{ base: "column", md: "row" }}
                        width={"100%"}
                      >
                        <Text
                          fontSize="sm"
                          mb={4}
                          textAlign="left"
                          mt={3}
                          width={"60%"}
                        >
                          Altere o status da proposta para Aguardando revisão do usuário na granatech
                        </Text>
                        <Button
                          bg="secondary"
                          color="white"
                          fontFamily="Lexend Deca"
                          borderRadius="md"
                          _hover={{ bg: "primary" }}
                          mb={4}
                          marginTop={4}
                          onClick={(event) => handleProposalPendingUserReview(event)}
                          px={{ base: 4, md: 8 }}
                          w={{ base: "100%", md: "auto" }}
                        >
                          Revisão do Usuário
                        </Button>
                      </Flex>

                      <Divider borderColor="gray.500" borderWidth="1px" />
                    </>
                  )
                  }
                  {getFixProposalIten === 'dt_pgto' && (
                    <>
                      <Text fontSize="2xl" mb={4} textAlign="left" width={"100%"}>
                        Alterar Data de Pagamento
                      </Text>
                      <Text fontSize="sm" mb={4} textAlign="left" width={"100%"}>
                        Altere a data de pagamento da prosta e atualize o status para
                        PAGA
                      </Text>
                      <></>
                      <CustomDatePicker
                        dateRange={paymentDate}
                        onChange={(date) => setPaymentDate(date)}
                        selectsRange
                      />
                      <></>
                      <Button
                        bg="secondary"
                        color="white"
                        fontFamily="Lexend Deca"
                        borderRadius="md"
                        _hover={{ bg: "primary" }}
                        marginTop={4}
                        onClick={(event) => handleUpdateProposalPaymentDate(event)}
                        px={{ base: 4, md: 8 }}
                        w={{ base: "100%", md: "auto" }}
                      >
                        Alterar data de pagamento
                      </Button>
                    </>
                  )}
                  {getFixProposalIten === "id_bancarizadora" && (
                    <>
                      <Text fontSize="2xl" mb={4} textAlign="left" width={"100%"}>
                        Alterar o id da proposta na bancarizadora
                      </Text>
                      <Text fontSize="sm" mb={4} textAlign="left" width={"100%"}>
                        Utilize esse recurso caso o id da proposta na granatech não
                        esteja igual ao id da proposta na bancarizadora.
                      </Text>
                      <></>
                      <Input
                        placeholder="Digite o novo ID da Proposta"
                        bg="white"
                        height="3rem"
                        color="black"
                        fontFamily="Lexend Deca"
                        fontSize="1rem"
                        value={externalId}
                        onChange={(e) => setExternalId(e.target.value)}
                      />
                      <></>
                      <Button
                        bg="secondary"
                        color="white"
                        fontFamily="Lexend Deca"
                        borderRadius="md"
                        _hover={{ bg: "primary" }}
                        marginTop={4}
                        onClick={(event) => handleUpdateProposalExternalId(event)}
                        px={{ base: 4, md: 8 }}
                        w={{ base: "100%", md: "auto" }}
                      >
                        Atualizar ID da Proposta
                      </Button>
                    </>
                  )}

                  {getFixProposalIten === "help" && (
                    <Text fontSize="2xl" mb={4}>
                      Novo ModalBody Sobreposto:: {getFixProposalIten}
                    </Text>
                  )}
                </ModalBody>
              )}

              <ModalBody p={{ base: 4, md: 6 }}>
                <Flex
                  justify="space-between"
                  flexDirection={{ base: "column", md: "row" }}
                >
                  <Text
                    fontSize={{ base: "2", md: "4xl" }}
                    color="secondary"
                    fontFamily="Lexend Deca"
                    textAlign="left"
                    mb={2}
                  >
                    Correções da Proposta
                  </Text>

                  {/* <IconButton
              aria-label="Altarar Status"
              icon={<FaQuestionCircle />}
              ml={2}
              onClick={() => handleFixProposal('help')}
              size={{ base: "lg", md: "sm" }}
              variant="ghost"
              color="gray.500"
            /> */}
                </Flex>

                <>
                  <VStack spacing={1} align="stretch">
                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Titular:
                      </Text>
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {proposal?.cliente_nome ?? "Não informado"}
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />
                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        CPF Titular:
                      </Text>
                      <>
                        <Text
                          fontSize={{ base: "md", md: "md" }}
                          fontFamily="Lexend Deca"
                          color="gray.500"
                        >
                          {proposal?.cliente_cpf
                            ? cpfFormatter(proposal?.cliente_cpf)
                            : "Não informado"}
                          <IconButton
                            aria-label="Copiar CPF"
                            icon={<FaRegCopy />}
                            onClick={() =>
                              handleCopy(
                                cpfFormatter(proposal?.cliente_cpf!)
                              )
                            }
                            size={{ base: "xl", md: "sm" }}
                            variant="ghost"
                            color="gray.500"
                            alignSelf="center"
                          />
                        </Text>
                      </>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />
                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Bancarizadora:{" "}
                      </Text>
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Não informado
                        {/* {proposal?.chosenFinancialInfo?.Product?.processor?.name ||
                      "-"} */}
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />
                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Tabela:{" "}
                      </Text>
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {oferta?.numberOfInstallments ? `${oferta.numberOfInstallments} Meses` : "-"}
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />
                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Banco:
                      </Text>
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {proposal?.numero_banco ?? "Não informado"}
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />

                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Agência:
                      </Text>
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {proposal?.agencia ?? "Não informado"}
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />

                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Digito Agência:
                      </Text>
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {proposal?.digito_agencia ?? "Não informado"}
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />

                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Conta:
                      </Text>
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {proposal?.conta ?? "Não informado"}
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />

                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Dígito Verificador:
                      </Text>
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {proposal?.digito_conta ?? "Não informado"}
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />

                    <Flex
                      justify="space-between"
                      width="100%"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Id da Proposta:
                      </Text>
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {proposal?.id_proposta ?? "Não informado"}
                        <IconButton
                          aria-label="Copiar Número da Proposta"
                          icon={<FaRegCopy />}
                          ml={2}
                          onClick={() => handleCopy(proposal?.id_proposta!)}
                          size={{ base: "xl", md: "sm" }}
                          variant="ghost"
                          color="gray.500"
                        />
                      </Text>
                    </Flex>

                    <Divider borderColor="gray.500" borderWidth="1px" />
                    <Flex
                      justify="space-between"
                      width="100%"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Número da Proposta:
                      </Text>
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {proposal?.short_hash ?? "Não informado"}
                        <IconButton
                          aria-label="Copiar Número da Proposta"
                          icon={<FaRegCopy />}
                          ml={2}
                          onClick={() => handleCopy(proposal?.short_hash!)}
                          size={{ base: "xl", md: "sm" }}
                          variant="ghost"
                          color="gray.500"
                        />
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />

                    <Flex
                      justify="space-between"
                      width="100%"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Data da Proposta:
                      </Text>
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {proposal?.data_proposta
                          ? format(
                            proposal?.data_proposta,
                            "dd/MM/yyyy - HH:mm"
                          )
                          : ""}
                      </Text>
                    </Flex>

                    <Divider borderColor="gray.500" borderWidth="1px" />
                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Data de Formalização:
                      </Text>
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {proposal?.data_formalizacao
                          ? format(
                            proposal?.data_formalizacao,
                            "dd/MM/yyyy - HH:mm"
                          )
                          : ""}
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />

                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Valor Liberado ao Cliente
                      </Text>
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {BrlCurrencyFormatter(
                          oferta?.releasedAmount
                        )}
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />

                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Prazo do Contrato
                      </Text>
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {oferta?.numberOfInstallments ?? "Erro ao obter anos"}
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />

                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Valor Descontado
                      </Text>
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {BrlCurrencyFormatter(oferta?.loanAmount)}
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />

                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Taxa A.M.
                      </Text>
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {oferta?.monthlyRate ?? "XXXXX"} %
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />

                    <Flex
                      justify="space-between"
                      width="100%"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Id Bancarizadora:
                      </Text>
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {proposal?.numero_ccb ?? "Não informado"}
                        <IconButton
                          aria-label="Copiar Número da Proposta"
                          icon={<FaRegCopy />}
                          ml={2}
                          onClick={() => handleCopy(proposal?.numero_ccb!)}
                          size={{ base: "xl", md: "sm" }}
                          variant="ghost"
                          color="gray.500"
                        />
                        <IconButton
                          aria-label="Copiar Número da Proposta"
                          icon={<FaPen />}
                          ml={2}
                          onClick={() => handleFixProposal("id_bancarizadora")}
                          size={{ base: "xl", md: "sm" }}
                          variant="ghost"
                          color="red.500"
                        />
                      </Text>
                    </Flex>

                    <Divider borderColor="gray.500" borderWidth="1px" />

                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Data do Pagamento:
                      </Text>

                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {proposal?.data_pagamento
                          ? format(proposal?.data_pagamento, "dd/MM/yyyy - HH:mm")
                          : "-"}
                        <IconButton
                          aria-label="Copiar Número da Proposta"
                          icon={<FaPen />}
                          ml={2}
                          onClick={() => handleFixProposal("dt_pgto")}
                          size={{ base: "xl", md: "sm" }}
                          variant="ghost"
                          color="red.500"
                        />
                      </Text>
                    </Flex>


                    <Divider borderColor="gray.500" borderWidth="1px" />

                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Status:
                      </Text>
                      <Flex
                        justify="right"
                        flexDirection={{ base: "column", md: "row" }}
                      >
                        <StatusRenderer
                          status={
                            ProposalStatus[
                            proposal?.status_proposta as keyof typeof ProposalStatus
                            ]
                          }
                          customStatus={proposal?.custom_status as string}
                        />
                        <IconButton
                          aria-label="Altarar Status"
                          icon={<FaPen />}
                          ml={2}
                          onClick={() => handleFixProposal("status")}
                          size={{ base: "xl", md: "sm" }}
                          variant="ghost"
                          color="red.500"
                        />
                      </Flex>


                    </Flex>

                    <Divider borderColor="gray.500" borderWidth="1px" />

                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Operações:
                      </Text>
                      <Flex
                        justify="flex-end"
                        flexDirection="row"
                        width="100%"
                        alignItems="center"
                        height="70px"
                      >
                        {isAcaoPermitida('cancelar e desbloquear', proposal?.status_proposta! as ProposalStatus) && (
                          <Button
                            bg="secondary"
                            color="white"
                            fontFamily="Lexend Deca"
                            borderRadius="md"
                            _hover={{ bg: "primary" }}
                            size="sm"
                            mx={1}
                            onClick={(event) => handleCancelProposal(event)}
                            px={4}
                            w="170px"
                            minW="170px"
                            fontSize="0.95rem"
                            whiteSpace="normal"
                            fontWeight="bold"
                            height="48px"
                          >
                            Cancelar
                          </Button>
                        )}

                        {isAcaoPermitida('trocar processo unico', proposal?.status_proposta! as ProposalStatus) && (
                          <Button
                            bg="secondary"
                            color="white"
                            fontFamily="Lexend Deca"
                            borderRadius="md"
                            _hover={{ bg: "primary" }}
                            size="sm"
                            mx={1}
                            onClick={handleChangeUnicoUnico}
                            px={4}
                            w="170px"
                            minW="170px"
                            fontSize="0.95rem"
                            whiteSpace="normal"
                            fontWeight="bold"
                            height="48px"
                          >
                            Trocar Processo Único
                          </Button>
                        )}
                        {isAcaoPermitida('alterar para pagamento', proposal?.status_proposta! as ProposalStatus) && (
                          <Button
                            bg="secondary"
                            color="white"
                            fontFamily="Lexend Deca"
                            borderRadius="md"
                            _hover={{ bg: "primary" }}
                            size="sm"
                            mx={1}
                            onClick={() => approveProsal()}
                            px={4}
                            w="170px"
                            minW="170px"
                            fontSize="0.95rem"
                            whiteSpace="normal"
                            fontWeight="bold"
                            height="48px"
                            disabled={
                              false
                              // !proposal?.UnicoData?.evidenceSet || !proposal?.UnicoData?.evidenceSet
                            }
                          >
                            Alterar para Pagamento
                          </Button>
                        )}

                        {isAcaoPermitida('corrigir proposta', proposal?.status_proposta! as ProposalStatus) && hasErrorCreateProposalBank(proposal?.custom_status!) && (
                          <Button
                            fontSize="0.94rem"
                            colorScheme="orange"
                            onClick={handleBankAndPersonalDataClick}
                            fontFamily="Lexend Deca"
                            size="sm"
                            minW="170px"
                            px={4}
                            whiteSpace="normal"
                            fontWeight="bold"
                            mx={1}

                          >
                            Corrigir Proposta
                          </Button>
                        )}
                        {isAcaoPermitida('corrigir dados biometricos', proposal?.status_proposta! as ProposalStatus) && hasErrorBiometricValidation(proposal?.custom_status!) && (
                          <Button
                            fontSize="0.94rem"
                            colorScheme="red"
                            onClick={handleButtonFormalizationClick}
                            fontFamily="Lexend Deca"
                            size="sm"
                            minW="170px"
                            px={4}
                            whiteSpace="normal"
                            fontWeight="bold"
                            mx={1}

                          >
                            Corrigir Dados Biométricos
                          </Button>
                        )}

                        {isAcaoPermitida('corrigir dados bancarios', proposal?.status_proposta! as ProposalStatus) && hasProposalBankDetailsError(proposal?.custom_status as string) && (
                          <Button
                            fontSize="0.94rem"
                            colorScheme="green"
                            onClick={handleBankDataClick}
                            fontFamily="Lexend Deca"
                            size="sm"

                            px={4}
                            minW="auto"
                            whiteSpace="nowrap"
                            fontWeight="bold"
                          >
                            Corrigir Dados Bancários
                          </Button>
                        )}


                      </Flex>


                    </Flex>

                    <Divider borderColor="gray.500" borderWidth="1px" />
                  </VStack>
                </>
              </ModalBody>
            </>)}
        </ModalContent>

        { }
      </Modal>
      <BankDetailModalConsignado
        isOpen={isBankDetailFormOpen}
        onClose={() => setIsBankDetailFormOpen(false)}
        proposalId={proposal?.id_proposta}
      />
      <BankAndPersonalDetailModal
        isOpen={isBankAndPersonalDetailFormOpen}
        onClose={() => setIsBankAndPersonalDetailFormOpen(false)}
        proposalId={proposal?.id_proposta}
      />
    </>

  );
}
